import { render, staticRenderFns } from "./ThirdShelvesManage.vue?vue&type=template&id=52d9a99a&scoped=true"
import script from "./ThirdShelvesManage.vue?vue&type=script&lang=js"
export * from "./ThirdShelvesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d9a99a",
  null
  
)

export default component.exports